import { gql } from '@apollo/client'

import * as Types from '../../types.generated'

export type IUserTagsQueryVariables = Types.Exact<{ [key: string]: never }>

export type IUserTagsQuery = {
  userTags?: Array<{
    id?: any | null
    value?: string | null
    color?: string | null
    isSystem?: boolean | null
  } | null> | null
}

export const UserTagsDocument = gql`
  query UserTags {
    userTags {
      id
      value
      color
      isSystem
    }
  }
`
